import Theme from '../../styles/Theme';

export const BRAND_MODES = {
  FOOD_AMIGOS: 'foodamigos',
  NEUTRAL: 'neutral',
  // A partner's own identity.
  PARTNER: 'partner',
};

/**
 * What {@link BRAND_MODES.PARTNER} was called before the partner/reseller rename.
 *
 * The mode is written into localStorage (`WHITE_LABEL_BRAND`), so browsers that
 * cached a brand before this deploy still hold the old string. `readCachedBrand`
 * accepts it and upgrades it in place; nothing writes it any more.
 *
 * TODO(2026-10-09): delete this and the `normaliseMode` call in brandCache.js.
 * The cache is rewritten on every logged-out visit with `?partner=` and on every
 * sign-in, so a month is far longer than it takes for live browsers to migrate —
 * and the only cost of a straggler is one neutral-branded login page.
 */
export const LEGACY_PARTNER_BRAND_MODE = 'reseller';

export const FOOD_AMIGOS_BRAND = {
  mode: BRAND_MODES.FOOD_AMIGOS,
  name: 'Restaurant dashboard',
  logoUrl: null,
  circleLogoUrl: null,
  splashImageUrl: null,
  primaryColor: Theme.color.brand.primary,
  language: 'de',
  languages: ['de', 'en'],
};

// Mirrors the backend's neutral fallback (config/branding.php) so an
// unreachable brand-config API or a missing partner slug degrades to the
// neutral identity — never to FoodAmigos.
export const NEUTRAL_BRAND = {
  mode: BRAND_MODES.NEUTRAL,
  name: 'Restaurant Dashboard',
  logoUrl: null,
  circleLogoUrl: null,
  splashImageUrl: null,
  primaryColor: '#161616',
  language: 'en',
  languages: ['en'],
};
